import { render, staticRenderFns } from "./PgtoNegado.vue?vue&type=template&id=ad9ee5aa&scoped=true&"
import script from "./PgtoNegado.vue?vue&type=script&lang=js&"
export * from "./PgtoNegado.vue?vue&type=script&lang=js&"
import style0 from "./PgtoNegado.vue?vue&type=style&index=0&id=ad9ee5aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad9ee5aa",
  null
  
)

export default component.exports